module.exports = __webpack_public_path__ + "static/img/1.4314bc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/changeBg/1.png
// module id = WgJ8
// module chunks = 0